<div class="main-container">
  <app-page-header pageTitle="Renewal Request"></app-page-header>

  <ng-container *ngIf="show === null; else voucherPage">
    <app-user-page-loader label="Loading renewal information"></app-user-page-loader>
  </ng-container>

  <ng-template #voucherPage>
    <div class="alert-details-container">
      <div class="banner-container">
        <topaz-banner *ngIf="status == 'EXPIRED'" bannerType="alert" useIcon disableScrolling disableCloseButton>
          <div banner-content>
            <b>Alert</b>
            <br />
            <span class="topaz-banner-subcontent">
              Your MCT Subscription expired on date : {{ timelinedate | date:'MM/dd/yyyy':'UTC' }}. Please renew your
              subscription to continue enjoying the benefits.
            </span>
          </div>
        </topaz-banner>

      </div>
    </div>

    <div class="card-container" *ngIf="show === true; else testoutForm">
      <mat-card class="renewal-card" aria-labelledby="short-card-title" appearance="outlined">

        <div>
          <div class="formTitle">
            Renewal Form
          </div>

          <mat-stepper linear [orientation]="(stepperOrientation | async)!" aria-label="Renewal form steps">
            <mat-step [stepControl]="personalInfoForm">
              <ng-template matStepLabel>Personal Information</ng-template>

              <form [formGroup]="personalInfoForm">
                <div class="form-row">
                  <mat-form-field class="form-field-flex salutation-field">
                    <mat-label>Salutation</mat-label>
                    <mat-select formControlName="salutation">
                      <mat-option *ngFor="let salutation of salutationList" [value]="salutation">
                        {{ salutation }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="personalInfoForm.get('salutation')?.hasError('required')">
                      Salutation is required
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="form-field-flex">
                    <mat-label>First Name</mat-label>
                    <input type="text" matInput formControlName="firstname" />
                    <mat-error *ngIf="personalInfoForm.get('firstname')?.hasError('required')">
                      First Name is required
                    </mat-error>

                    <mat-error *ngIf="personalInfoForm.get('firstname')?.hasError('pattern')">
                      First name can contain only letters
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="form-field-flex">
                    <mat-label>Last Name</mat-label>
                    <input type="text" matInput formControlName="lastname" />
                    <mat-error *ngIf="personalInfoForm.get('lastname')?.hasError('required')">
                      Last Name is required
                    </mat-error>

                    <mat-error *ngIf="personalInfoForm.get('lastname')?.hasError('pattern')">
                      Last name can contain only letters
                    </mat-error>
                  </mat-form-field>
                </div>

                <mat-form-field class="form-field-flex">
                  <mat-label>Pronouns</mat-label>
                  <mat-select formControlName="pronouns">
                    <mat-option *ngFor="let pronoun of pronounsList" [value]="pronoun">
                      {{ pronoun }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="personalInfoForm.get('pronouns')?.hasError('required')">
                    Pronouns are required
                  </mat-error>
                </mat-form-field>


                <mat-form-field>
                  <mat-label>Email</mat-label>
                  <input type="text" matInput formControlName="email" />
                  <mat-error>Email required</mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Country</mat-label>
                  <mat-select formControlName="country" aria-label="Country" (selectionChange)="onCountryChange($event)">
                    <mat-option *ngFor="let option of countryList" [value]="option.countryName">
                      {{ option.countryName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="personalInfoForm.get('country')?.hasError('required')">
                    Select a country
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Timezone</mat-label>
                  <mat-select formControlName="timezone" aria-label="Timezone">
                    <mat-option *ngFor="let option of timezoneList" [value]="option.timeZone">
                      {{ '(GMT' + option.utcOffset + ') ' + option.displayName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="personalInfoForm.get('timezone')?.hasError('required')">
                    Select the Timezone
                  </mat-error>
                </mat-form-field>

                <div class="step-action">
                  <button class="step-next" mat-flat-button matStepperNext type="button"
                    aria-label="Continue to renewal details">
                    Next
                  </button>
                </div>

              </form>

            </mat-step>

            <mat-step [stepControl]="renewalDetailsForm">
              <ng-template matStepLabel>Renewal Details</ng-template>

              <form [formGroup]="renewalDetailsForm">

                <mat-form-field>
                  <mat-label>Training Delivery Locations</mat-label>
                  <mat-select formControlName="primarySupportRegions" multiple aria-label="Country">
                    <mat-option *ngFor="let option of countryList" [value]="option.countryName">
                      {{ option.countryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Instructional Language</mat-label>
                  <mat-select formControlName="renewalLanguage" multiple aria-label="Instructional Language">
                    <mat-option *ngFor="let option of languageList" [value]="option.name">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="transcript-fields">

                  <mat-form-field>
                    <mat-label>Microsoft Learn transcript URL</mat-label>
                    <input type="text" matInput formControlName="transScriptUrl" />
                      <mat-hint class="mat-error" *ngIf="renewalDetailsForm.get('transScriptUrl')?.touched && renewalDetailsForm.get('transScriptUrl')?.hasError('required')">
                          Microsoft Learn transcript URL is required
                      </mat-hint>
                      <mat-hint class="mat-error" *ngIf="renewalDetailsForm.get('transScriptUrl')?.touched && renewalDetailsForm.get('transScriptUrl')?.hasError('invalidUrl')">
                        Please enter a valid URL (e.g., https://www.example.com)
                      </mat-hint>

                    <mat-hint
                      *ngIf="renewalDetailsForm.get('transScriptUrl')?.valid && renewalDetailsForm.get('transScriptUrl')?.value"
                      align="end" style="cursor: pointer;" role="button" tabindex="0" (click)="onClickTesturl()"
                      (keydown.enter)="onClickTesturl()"
                      (keydown.space)="onClickTesturl(); $event.preventDefault()">
                      Click here to verify the url
                    </mat-hint>

                    <mat-hint class="divider"
                      *ngIf="renewalDetailsForm.get('transScriptUrl')?.valid && renewalDetailsForm.get('transScriptUrl')?.value"
                      align="end"><mat-divider [vertical]="true"></mat-divider>
                    </mat-hint>

                    <mat-hint align="end" style="cursor: pointer;" role="button" tabindex="0" (click)="getTranscript()"
                      (keydown.enter)="getTranscript()" (keydown.space)="getTranscript(); $event.preventDefault()">
                      How to access your Learn Transcript?
                    </mat-hint>
                  </mat-form-field>
                </div>

                <mat-form-field>
                  <mat-label>Personal Website</mat-label>
                  <input type="text" matInput formControlName="website" />
                  <mat-error *ngIf="renewalDetailsForm.get('website')?.hasError('invalidUrl')">
                    Please enter a valid URL (e.g., https://www.example.com)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>LinkedIn URL</mat-label>
                  <input type="text" matInput formControlName="linkedInUrl" />
                  <mat-error *ngIf="renewalDetailsForm.get('linkedInUrl')?.hasError('invalidUrl')">
                    Please enter a valid URL (e.g., https://www.linkedin.com/in/username)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Solution Areas</mat-label>
                  <mat-select formControlName="solutionAreas" multiple aria-label="Solution Areas">
                    <mat-option *ngFor="let solutionArea of solutionAreasList" [value]="solutionArea">
                      {{ solutionArea }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="renewalDetailsForm.get('solutionAreas')?.hasError('required')">
                    Select at least one solution area
                  </mat-error>
                  <mat-hint class="appendix-link" align="end" role="button" tabindex="0"
                    (click)="openAppendixA()" (keydown.enter)="openAppendixA()"
                    (keydown.space)="openAppendixA(); $event.preventDefault()">
                    See APPENDIX A if more comprehensive list needed
                  </mat-hint>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Active Statuses</mat-label>
                  <mat-select formControlName="activeStatuses" multiple aria-label="Active Statuses">
                    <mat-option *ngFor="let activeStatus of activeStatusesList" [value]="activeStatus">
                      {{ activeStatus }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Top 3 Technical Areas</mat-label>
                  <mat-select formControlName="topTechnicalAreas" multiple aria-label="Top 3 Technical Areas">
                    <mat-option *ngFor="let technicalArea of topTechnicalAreasList" [value]="technicalArea">
                      {{ technicalArea }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="renewalDetailsForm.get('topTechnicalAreas')?.hasError('required')">
                    Select at least one technical area
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Approximately how many Microsoft Technology courses do you teach in a year?</mat-label>
                  <input matInput type="number" min="0" max="999" step="1" formControlName="microsoftTechnologyCoursesPerYear" />
                  <mat-error *ngIf="renewalDetailsForm.get('microsoftTechnologyCoursesPerYear')?.hasError('required')">
                    Enter the number of Microsoft Technology courses you teach in a year
                  </mat-error>
                  <mat-error *ngIf="renewalDetailsForm.get('microsoftTechnologyCoursesPerYear')?.hasError('pattern')">
                    Please enter a whole number only
                  </mat-error>
                  <mat-error *ngIf="renewalDetailsForm.get('microsoftTechnologyCoursesPerYear')?.hasError('max')">
                    Please enter a value less than or equal to 999
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Approximately what percentage of your training deliveries come through a TSP?</mat-label>
                  <mat-select formControlName="tspDeliveryPercentage">
                    <mat-option [value]="0">0</mat-option>
                    <mat-option [value]="10">10%</mat-option>
                    <mat-option [value]="25">25%</mat-option>
                    <mat-option [value]="50">50%</mat-option>
                    <mat-option [value]="75">75%</mat-option>
                    <mat-option [value]="90">90%</mat-option>
                    <mat-option [value]="100">100%</mat-option>
                  </mat-select>
                  <mat-error *ngIf="renewalDetailsForm.get('tspDeliveryPercentage')?.hasError('required')">
                    Select the percentage of training deliveries that come through a TSP
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="textarea-field">
                  <mat-label>Awards/Recognitions</mat-label>
                  <textarea matInput formControlName="awardsRecognitions" #awardsTextarea maxlength="500"
                    rows="4"></textarea>
                  <mat-hint align="end">{{ awardsTextarea.value.length }} / 500</mat-hint>
                </mat-form-field>

                <mat-form-field class="textarea-field">
                  <mat-label>Short Biography</mat-label>
                  <textarea matInput formControlName="shortBiography" #biographyTextarea maxlength="500"
                    rows="4"></textarea>
                  <mat-hint align="end">{{ biographyTextarea.value.length }} / 500</mat-hint>
                </mat-form-field>

                <div class="step-action">
                  <button class="step-previous" mat-stroked-button matStepperPrevious type="button"
                    aria-label="Back to personal information">
                    Back
                  </button>
                  <button class="step-next" mat-flat-button matStepperNext type="button"
                    aria-label="Continue to confirmation">
                    Next
                  </button>
                </div>
              </form>
            </mat-step>

            <mat-step [stepControl]="confirmationForm">
              <ng-template matStepLabel>Confirmation</ng-template>

              <form [formGroup]="confirmationForm">
                <div class="topaz-checkbox-group-col">
                  <p style="font-size: 13px; color: #595959; margin-bottom: 8px;margin-left:10px">
                    <em>Note: You must review the MCT Program Agreement through the link below before you can check the
                      box
                      to accept it.</em>
                  </p>
                  <div class="basic-checkboxes">
                    <mat-checkbox matInput formControlName="mctAgreement" [(ngModel)]="isCheckboxSelected"
                      [ngClass]="{'is-invalid': !isCheckboxSelected && formSubmitted }" class="white-check-icon"
                      id="requiredCheckbox"
                      aria-label="I acknowledge that I have read and agree to the terms of the MCT Program Agreement">
                    </mat-checkbox>
                      I have Read and Agreed to the <a href="javascript:void(0)" (click)="agrementDoc()"
                      (keydown.enter)="agrementDoc(); $event.stopPropagation()" aria-live="polite"
                      [attr.aria-label]="'MCT Program Agreement (downloads PDF file, 150KB)'">MCT Program Agreement Terms</a><br/> 
                      I understand that my MCT renewal is valid for one year. 
                      I acknowledge that the renewal requirements for the next MCT renewal cycle may differ from current requirements and 
                      will be communicated via email and the MCT Lounge no later than May 1, 2027.
                  </div>
                  <div>
                    <mat-error class="is-invalid" *ngIf="!isCheckboxSelected && formSubmitted">
                      You must accept the Agreement to continue
                    </mat-error>
                  </div>
                </div>

                <div class="directory-opt-out-field">
                  <div class="directory-opt-out-label">MCT Directory Opt-out</div>
                  <div>
                    Microsoft is exploring the creation of an MCT Directory that would enable MCTS, 
                    prospective customers, partners, and other approved audiences to discover MCTs based on factors such as location, 
                    expertise, certifications, and training delivery capabilities. Additional details regarding the directory and 
                    participant profile information will be communicated at a later date. If you DO NOT wish to be included in the 
                    directory, please check the box below.
                  </div>
                  <mat-checkbox formControlName="mctDirectoryOptOut" class="white-check-icon"
                    aria-label="Do not participate in the MCT Directory">
                  </mat-checkbox>
                  <span class="directory-opt-out-description"><strong>I DO NOT wish to participate in the MCT Directory. I
                      understand that, if a directory is launched, my information WILL NOT be included or made visible to
                      directory users unless I choose to opt in at a later time.</strong></span>
                </div>

                <div class="step-action">
                  <button class="step-previous" mat-stroked-button matStepperPrevious type="button"
                    aria-label="Back to renewal details">
                    Back
                  </button>
                  <button class="submitButton step-next" [disabled]="disableSubmit" mat-flat-button type="button"
                    (click)="submit()">
                    Submit
                  </button>
                </div>
              </form>
            </mat-step>
          </mat-stepper>
        </div>
      </mat-card>

      <div class="renewal-details" *ngIf="status == 'ACTIVE_MCT'">
        <mat-card aria-labelledby="short-card-title" appearance="outlined">
          <div class="note-container">
            <div class="note-content">
              <div class="card-heading">Renewal Requirements:</div>
              <div class="renewal-header-description">
                <span>
                  For all MCTs whose status expires between October 1, 2026 and May 31, 2027, the renewal requirements are as follows:
                </span>
              </div>

              <div class="note-section">
                <strong>1.</strong> You must complete and submit the renewal application in its entirety.
              </div>

              <div class="note-section">
                <span>
                 <strong>2.</strong> You must have taught 6-training sessions, logged in MTM against your MCT email address 
                      (the email ID used to sign into this portal). 
                      You may use custom courses in order to fulfil this requirement. 
                      For instructions, please visit:
                      <a href="https://aka.ms/MTM_User_Guide" target="_blank" rel="noopener noreferrer">aka.ms/MTM_User_Guide</a>
                </span>
                <span class="renewal-req-note">
                  <strong>Please Note:</strong> 
                  MTM data is synced to the portal biweekly. If you have recently logged a class on MTM, 
                  it may take up to 14 days for your updated renewal eligibility to be reflected in the portal. 
                  To track your progress, you can view how many classes you have logged against your MCT Profile by clicking on 
                  the "My Profile" tab under your name on the top right of your screen.
                </span>
              </div>

              <div class="note-section">
                <span>
                 If you do not meet the 6-session renewal requirement, 
                 an alternative renewal pathway in the form of the MCT Renewal Assessment will be made available to you upon 
                 completion of your renewal application. To learn more about the MCT Renewal Assessment, 
                 please visit: <a href="https://aka.ms/MCT_Renewal_Assessment" target="_blank" rel="noopener noreferrer">aka.ms/MCT_Renewal_Assessment</a>
                </span>
              </div>

              <div class="note-section">
                <span>
                  If you choose to proceed with the Renewal Assessment, you will not be able to revert back to the 6-session requirement.
                </span>
              </div>

              <div class="note-section">
                <div class="renewal-section-title"> <strong>3.</strong> You must pay your annual renewal fee.</div>
                <strong>Please Note:</strong> If you are a Microsoft FTE, your renewal requirements have changed, 
                and the above processes do not apply to you. Please visit <a href="https://aka.ms/MCT4FTE">aka.ms/MCT4FTE</a> for more info.
              </div>

            </div>
          </div>
        </mat-card>

        <mat-card aria-labelledby="short-card-title" appearance="outlined">
          <div class="note-container">
            <div class="note-icon">
              <!-- <fa-icon></fa-icon> -->
            </div>
            <div class="note-content">
              <div class="note-title">Need help?</div>
              <div class="note-description">
                <p>
                  For questions, please contact us at
                  <a aria-label="Email MCT Support at mctpvsupport@pearson.com"
                    href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>
                  - we’re here to help!
                </p>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>



    <ng-template #testoutForm>
      <div class="card-container" *ngIf="show === false">
        <mat-card *ngIf="status === 'RENEWAL_REJECT'" class="testout-card" appearance="outlined">
          <div class="formTitle">Renewal Status:</div>
          <p class="testout-message">
            Thank you for completing your renewal application.
          </p>
          <p class="testout-message">
           Unfortunately, our records indicate that you have not met the 6-session renewal requirement.
          </p>

          <div *ngIf="status=='RENEWAL_REJECT' && renewalRejectReasons.length > 0">
            <ul>
              <li *ngFor="let reason of renewalRejectReasons">{{ reason.reasonText }}</li>
            </ul>
          </div>

          <div  class="testout-message">
           <strong>Fortunately, you are eligible for our alternative renewal pathway.</strong>
          </div>

          <div class="formTitle">About the alternative renewal pathway:</div>
          <div class="testout-message">
            The MCT Renewal Assessment is a 30-45 minute AI-based role play assessment. The assessment is provided at no cost and passing it will qualify you for MCT renewal.
          </div>

          <div class="testout-message">
            To learn more about the MCT Renewal Assessment, please visit <a href="https://aka.ms/MCT_Renewal_Assessment" target="_blank" rel="noopener noreferrer"><strong>aka.ms/MCT_Renewal_Assessment</strong></a>.
          </div>

          <div class="formTitle">Disclaimer:</div>
          <div class="testout-message">
           If you elect to proceed with the Renewal Assessment, you will no longer be eligible to renew your subscription by 
           meeting the 6-session requirement. To renew your MCT status, you must pass the assessment on your first attempt.
          </div>
          <div class="testout-message">
            Upon successful registration, you will receive an email with instructions for completing the assessment. 
            Please note that it may take up to 72 business hours for assessment results to be reflected in the MCT Portal. Please plan accordingly.
          </div>

          <p class="testout-message">
            To proceed, please click on the assessment registration link below:
            <br/>
            <a href="#" (click)="$event.preventDefault(); openYoodliConfirmation()"
              aria-label="Register for Yoodli"><strong>Register for the MCT Renewal Assessment</strong>
            </a>
          </p>

          <div class="testout-message">
           Once you have completed your registration, assessment details and further instructions will be sent to your registered 
           MCT email address. If you pass the assessment, your MCT renewal application will proceed toward approval, 
           and you will simply need to submit payment to complete the renewal process.
          </div>

          <div>
            <strong>Please Note:</strong> 
            If you did not meet the 6-session requirement, and/or if you fail the MCT Renewal Assessment, 
            your MCT status will have lapsed. As such, you will need to re-enter the program using the fee-based MCT Instructional Skills Assessment.
          </div>
        </mat-card>


        <mat-card *ngIf="status === 'RENEWAL_EXAM'" class="testout-card" appearance="outlined">
          <div class="formTitle">MCT Renewal Assessment Registration Successful</div>
          <div class="testout-message">
            You have successfully registered for the MCT Renewal Assessment. 
            You will receive an email from our assessment partner, <strong>Yoodli</strong>, within the next 48 hours. 
            The email will provide access to the Yoodli platform, where you will complete the <strong>MCT Renewal Assessment</strong>.
          </div>
          <div class="testout-message">
            If you pass the assessment, your MCT renewal application will proceed toward approval, 
            and you will simply need to submit payment to complete the renewal process.
          </div>
          <div class="testout-message">
            If you do not pass the assessment in your first attempt, 
            your MCT status will lapse and you will need to re-enter the program through the fee-based 
            MCT Instructional Skills Assessment pathway.
          </div>
          <div class="testout-message">
            Please allow up to 72 business hours post assessment completion, for results to be updated on the MCT Portal.
          </div>
          <div class="testout-message">
            <p>
              For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com"
                href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>. we’re here to help
            </p>
          </div>
        </mat-card>

      </div>
    </ng-template>
  </ng-template>
</div>